// extracted by mini-css-extract-plugin
module.exports = {"root":"jHilpZ","dot":"jFJupq","active":"FqmkbP","play":"NsWt3c"};